import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSuperadminAuth } from '../../context/SuperadminAuthContext';
import './SuperadminLoginPage.css';

const SuperadminLoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();
  const { login } = useSuperadminAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      const loggedIn = await login(username, password);
      const defaultTarget = '/superadmin/companies';
      // Staff limite (menu_keys = tableau) : "Companies" n'est pas forcement
      // accorde — atterrir dessus quand meme renverrait aussitot vers le 1er
      // item permis via RequireSuperadminAuth, un aller-retour inutile.
      const target = Array.isArray(loggedIn.menu_keys)
        ? (loggedIn.menu_keys.includes(defaultTarget) ? defaultTarget : (loggedIn.menu_keys[0] || defaultTarget))
        : defaultTarget;
      navigate(target);
    } catch (err) {
      setError('Utilisateur ou mot de passe incorrect.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="sal-page">
      <div className="sal-card">
        <img className="sal-logo" src="/logo-cgl.png" alt="CGL Multi-services" />
        <h2 className="sal-title">Superadmin</h2>
        <form onSubmit={handleSubmit}>
          <div className="sal-group">
            <label className="sal-label">Utilisateur</label>
            <input
              type="text"
              className="sal-input"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>
          <div className="sal-group">
            <label className="sal-label">Mot de passe</label>
            <input
              type="password"
              className="sal-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          {error && <p className="sal-error">{error}</p>}
          <button type="submit" className="sal-btn" disabled={submitting}>
            {submitting ? 'Connexion...' : 'Connecter'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default SuperadminLoginPage;
